import { useState } from 'react'
import RoundedBorderButton from '../buttons/RoundedBorderButton'
import RoundedButton from '../buttons/RoundedButton'
import DatePickerInput2 from '../../components/inputs/DatePickerInput2'
import Modal from '@mui/material/Modal'
import close from '../../assets/close.png'
import strings from '../../res/strings'

const ReportsModal = (props) => {
    const [startDate, setStartDate] = useState(null)
    const [startDateError, setStartDateError] = useState(null)
    const [startDateSelected, setStartDateSelected] = useState(false)

    const [endDate, setEndDate] = useState(null)
    const [endDateError, setEndDateError] = useState(null)
    const [endDateSelected, setEndDateSelected] = useState(false)

    // Handle changes in date input for start date
    const onChangeStartDate = (selectedDate, context) => {
        if(context.validationError === 'invalidDate') {
            setStartDateSelected(false)
        } else if (!selectedDate){
            setStartDateSelected(false)
        } else {
            setStartDate(selectedDate)
            setStartDateSelected(true)
        }
    }

    // Handle when date is selected in date input for start date
    const onAcceptStartDate = (selectedDate) => {
        setStartDate(selectedDate)
        setStartDateSelected(true)
    }

    // Handle errors in date input for start date
    const onErrorStartDate = (error) => {
        if(error) {
            setStartDateError(strings.invalidDate)
        } else {
            setStartDateError(null)
        }
    }

    // Handle changes in date input for end date
    const onChangeEndDate = (selectedDate, context) => {
        if(context.validationError === 'invalidDate') {
            setEndDateSelected(false)
        } else if (!selectedDate){
            setEndDateSelected(false)
        } else {
            setEndDate(selectedDate)
            setEndDateSelected(true)
        }
    }

    // Handle when date is selected in date input for end date
    const onAcceptEndDate = (selectedDate) => {
        setEndDate(selectedDate)
        setEndDateSelected(true)
    }

    // Handle errors in date input for end date
    const onErrorEndDate = (error) => {
        if(error) {
            setEndDateError(strings.invalidDate)
        } else {
            setEndDateError(null)
        }
    }

    // Handles date formatting
    const formatDate = (timeStamp) => {
        const date = new Date(timeStamp)
        const day = date.getDate()
        const month = date.getMonth() + 1
        const year = date.getFullYear()
        return `${year}-${month < 10 ? '0' + month : month}-${day < 10 ? '0' + day : day}`
    }

    // Handles the generation of the report between dates
    const generateReportBetweenDates = () => {
        props.setIsLoading()

        const start = formatDate(startDate)
        const end = formatDate(endDate)

        fetch(`/api/Schedule/ExportToExcel?harborId=${props.harborId}&startDate=${start}&endDate=${end}`, {
            method:'GET',
            headers: { 
              'Accept': 'application/json',
              'Content-Type': 'application/json; charset=UTF-8',
              'Authorization': 'Bearer ' + props.jwtToken
            }, 
            mode: 'cors'
        }).then(async response => {
            setTimeout(async () => {
                props.setIsNotLoading()

                if (response.status === 200) {
                    const filename = `Relatório de agendamentos (${start} - ${end}).xlsx`
                    
                    const blob = await response.blob()
                    
                    const link = document.createElement('a')
                    link.href = window.URL.createObjectURL(blob)
                    link.download = filename
                    
                    document.body.appendChild(link)
                    link.click()
                    document.body.removeChild(link)

                    props.onClose()
                    resetVariables()
                } else if(response.status === 404) {
                    props.showErrorToast(strings.noSchedulesFoundError)
                } else {
                    props.showErrorToast(strings.exportToExcelError)
                }
                
            }, 1000)
        }).catch((error) => {
            setTimeout(() => {
                props.setIsNotLoading()
                props.showErrorToast(error)
            }, 1000)
        })
    }

    const resetVariables = () => {
        setStartDate(null)
        setStartDateError(null)
        setStartDateSelected(false)

        setEndDate(null)
        setEndDateError(null)
        setEndDateSelected(false)
    }

    return (
        <Modal
            className='flex items-center justify-center'
            disableAutoFocus={true}
            open={props.open}
            onClose={props.onClose}
        >
            <div className='bg-white justify-center item-center mx-4 pt-4 pb-5 rounded-[0.625rem]'>

                <div className='flex flex-row justify-between items-center px-6'>
                    <p className='font-montserrat font-semibold text-accent'>{strings.generateReport}</p>

                    <button onClick={props.onClose}>
                        <img className='h-3 w-3 ' src={close} alt='Fechar'/>
                    </button>
                </div>

                <div className='h-px bg-neutral3 my-4'/>

                <div className='px-6'>

                    <div className='flex flex-row mt-6 space-x-6'>

                        <div className='flex flex-1 flex-col'>
                            <label htmlFor='startDate' className='font-montserrat font-semibold text-sm mb-1.5'>{strings.startDate}</label>
                            <DatePickerInput2 
                                value={startDate}
                                onChange={onChangeStartDate}
                                onAccept={onAcceptStartDate}
                                onError={onErrorStartDate}
                            />
                            <p className='font-montserrat text-sm font-medium text-negative mt-1.5 h-2'>{startDateError ? startDateError : ''}</p>
                        </div>

                        <div className='flex flex-1 flex-col'>
                            <label htmlFor='endDate' className='font-montserrat font-semibold text-sm mb-1.5'>{strings.endDate}</label>
                            <DatePickerInput2 
                                value={endDate}
                                minDate={startDate}
                                onChange={onChangeEndDate}
                                onAccept={onAcceptEndDate}
                                onError={onErrorEndDate}
                                disabled={startDateSelected ? false : true}
                            />
                            <p className='font-montserrat text-sm font-medium text-negative mt-1.5 h-2'>{endDateError ? endDateError : ''}</p>
                        </div>

                    </div>

                    <div className='flex flex-row mt-10 space-x-4'>

                        <div className='flex flex-1 w-40'>
                            <RoundedBorderButton
                                text={strings.cancel}
                                onClick={props.onClose} 
                                height={48}
                                fontWeight='700'
                            />
                        </div>

                        <div className='flex flex-1 w-40'>
                            <RoundedButton 
                                onClick={generateReportBetweenDates}
                                text={strings.generateReport}
                                height={48}
                                bgColor='#007EB4'
                                disabled={startDateSelected && endDateSelected ? false : true}
                            />
                        </div>
                        
                    </div>

                </div>
            
            </div>
        </Modal>
    )
}

export default ReportsModal